import actions from "./actions";
import mutations from "./mutations";

const state = {
  stepIndex: 1,
  showEdit: false,
  tempUser: [],
  tempPayment: [],
  tempBank: [],
  resultGrade: [],
  resultCostCenter: [],
  resultWorkLoc: [],
  tempOther: [],
  idUser: null,
  resultKaryawan: [],
  cekUser: null,
  username: null,
  religions: [],
  marital_status: [],
  list_resign_type: [],
  temp_job: [],
  tax_dll: [],
  resultRole: [],
  resEmp: [],
  params: null
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
